/* ============================================================================
   CY MENU ART
   Brings the desktop mega-panel treatment into the mobile drawer: card artwork,
   the card's two-line name/sub wording, the Explore Features call to action,
   and a standalone WhatsApp action below the help notice.

   Where the content comes from matters. The theme serves ONE html document to
   every breakpoint - the desktop mega panels are in the DOM on a phone too,
   just hidden by CSS - so the artwork AND the wording are already on the page.
   This reads href -> {img, name, sub} straight off the .cy-mega__card-link
   elements rather than hardcoding any of it.

   That means no file_url lookups, no second copy of the copy to keep in sync,
   and no build step: change a card in header-group.json and the drawer follows
   on the next load. The Shopify menu only has to carry the card's NAME; the
   sub line is attached here, so the two can never drift apart.
   ========================================================================== */
(function () {
  'use strict';

  /* v3: the group name is no longer the gate.

     This used to only decorate rows inside a group called "Shop by ...".
     The v3 rail names its groups after the ranges themselves - "Artemis",
     "Desk Mats", "APEX 2.0 Premium - Same Comfort for Less" - so a name test
     would have to list all thirteen and would break on the next one added.

     The map is a better gate than any name: it is built from the desktop
     cards, so a row is decorated exactly when a card exists for its href, and
     rows that are not cards (Compare, View All, everything under Support) are
     skipped because they are simply not in it. */
  /* the loud action in each panel. 2026-10-02 (owner, mobile-menu unlock): a "... Features" link gets the same button as
     Compare (Mouse Pads has nothing to compare, its action is Mouse Pad Features) */
  var CTA_LABEL = /^compare |\bfeatures$/i;

  var WHATSAPP = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.96L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 18.15h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.11.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.23 8.24-8.23a8.19 8.19 0 0 1 8.23 8.24c0 4.54-3.7 8.23-8.23 8.23Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.78.97-.14.16-.29.18-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.5.11-.11.25-.29.37-.43.12-.15.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43h-.47c-.17 0-.43.06-.66.31-.23.25-.86.85-.86 2.07 0 1.21.89 2.39 1.01 2.55.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.11-.23-.17-.48-.29Z"/></svg>';

  var ARROW = '<svg class="cy-mb-cta__arrow" viewBox="0 0 14 10" aria-hidden="true" focusable="false">' +
    '<path d="M9 1l4 4-4 4M13 5H1" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* /collections/x?utm=1 and https://host/collections/x both key as
     /collections/x, so drawer and panel links match however each was authored.

     `variant` is the one parameter that must survive. Dropping the whole query
     collapsed every colourway of a model onto one key - both Akula 99 rows
     matched the Signature Edition card and rendered with its picture and its
     pill, and the same for every Artemis, Xeus and Nighthawk pair. The variant
     id is what makes those cards different, so it belongs in the key. */
  function key(href) {
    if (!href) return '';
    var parts = href.split('#')[0].split('?');
    var path = parts[0].replace(/^https?:\/\/[^/]+/, '').replace(/\/+$/, '').toLowerCase();
    var variant = parts[1] ? (/(?:^|&)variant=(\d+)/.exec(parts[1]) || [])[1] : null;
    return variant ? path + '?variant=' + variant : path;
  }

  function buildMap() {
    var map = {};
    document.querySelectorAll('.cy-mega__card-link').forEach(function (a) {
      /* Skip the View All tail card. It is a destination with no artwork, and
         leaving it in the map made the drawer treat its own View All row as a
         product: wrapped, tagged cy-has-art, and rendered as a card with an
         empty 84px image well above grey sentence-case text. */
      if (a.closest('.cy-mega__card--viewall')) return;
      var k = key(a.getAttribute('href'));
      if (!k || map[k]) return;
      var img = a.querySelector('img');
      var name = a.querySelector('.cy-mega__name');
      var sub = a.querySelector('.cy-mega__sub');
      /* the drawer card mirrors the desktop card: art, name, variant line and
         the corner tag (no price or stock line since 2026-09-27) */
      var tag = a.querySelector('.cy-mega__tag');
      var stock = a.querySelector('.cy-mega__stock');
      map[k] = {
        stock: stock,
        src: img ? (img.currentSrc || img.getAttribute('src')) : null,
        name: name ? name.textContent.trim() : '',
        sub: sub ? sub.textContent.trim() : '',
        tag: tag,
        brand: !!a.closest('.cy-mega__card--brand')
      };
    });
    return map;
  }

  /* ---- artwork + two-line wording on the card rows --------------------- */
  /* The card grid is OPT-IN per group: a third-level list only becomes a
     2-column card grid when at least one of its rows matches a desktop card.
     The Support groups (FAQ, Contact Us, Warranty...) match nothing, so they
     keep the theme's plain list rows - styling them as a wall of little
     bordered buttons was the v7 defect the owner flagged. */
  /* The View All tail carries the desktop View All card's info (2026-09-27):
     "View All ->", the name, the qualifier - "APEX Premium" over "Officially
     Licensed Editions" - read from the desktop card with the same href, not
     the raw menu title ("View All — APEX Premium"), so the two APEX tails no
     longer read alike. No desktop card -> the title minus its "View All" part. */
  function decorateViewAll(a) {
    if (a.classList.contains('cy-mb-va')) return;               /* never twice */
    var text = a.querySelector('.hdt-menu-link-text');
    if (!text) return;
    var name = '', sub = '';
    var k = key(a.getAttribute('href'));
    document.querySelectorAll('.cy-mega__card--viewall > .cy-mega__card-link').forEach(function (v) {
      if (name || key(v.getAttribute('href')) !== k) return;
      var n = v.querySelector('.cy-mega__name');
      var s = v.querySelector('.cy-mega__sub');
      name = n ? n.textContent.trim() : '';
      sub = s ? s.textContent.trim() : '';
    });
    if (!name) name = (text.textContent || '').trim().replace(/^view all\s*[—–-]?\s*/i, '');
    a.classList.add('cy-mb-va');
    var kicker = document.createElement('span');
    kicker.className = 'cy-mb-va-kicker';
    kicker.innerHTML = 'View All' + ARROW;
    a.insertBefore(kicker, text);
    text.textContent = name;
    if (sub) {
      var s2 = document.createElement('span');
      s2.className = 'cy-mb-sub';
      s2.textContent = sub;
      text.insertAdjacentElement('afterend', s2);
    }
  }

  function decorateCards(map) {
    document.querySelectorAll('.hdt-header-menu-mobile .hdt-mb-sub-menu-lever-2').forEach(function (ul) {
      var anchors = ul.querySelectorAll('a.hdt-menu-link');
      var hits = 0;
      anchors.forEach(function (a) { if (map[key(a.getAttribute('href'))]) hits++; });
      if (!hits) return;                       /* a link group, not a card group */
      ul.classList.add('cy-mb-cards');

      anchors.forEach(function (a) {
        if (a.classList.contains('cy-has-art')) return;          /* never twice */
        var d = map[key(a.getAttribute('href'))];
        if (!d) {
          /* no card matched THIS row - it is the group's View All tail */
          a.classList.add('cy-mb-plain');
          /* the grid item is the LI, not the anchor - grid-column on the
             anchor is a no-op, which left the row squatting in one cell */
          var pli = a.closest('li');
          if (pli) pli.classList.add('cy-mb-plain-li');
          decorateViewAll(a);
          return;
        }
        var text = a.querySelector('.hdt-menu-link-text');
        if (!text) return;

        /* the label and its sub become one column, so the thumbnail sits
           beside the pair rather than beside the first line only */
        var copy = document.createElement('span');
        copy.className = 'cy-mb-copy';
        a.insertBefore(copy, text);
        copy.appendChild(text);

        /* The Shopify menu row carries the full "Artemis — Black" title so it
           reads correctly with no JS; once decorated, the card takes the
           desktop card's own name/sub split instead. */
        if (d.name) text.textContent = d.name;

        /* Long names were being asked to fit one line and wrapping badly.
           The desktop card already splits them - "APEX 2.0 Premium" over
           "Official Licensed Editions" - so reuse that split rather than
           inventing a second one. */
        if (d.sub) {
          var sub = document.createElement('span');
          sub.className = 'cy-mb-sub';
          sub.textContent = d.sub;
          copy.appendChild(sub);
        }
        var meta = document.createElement('span');
        meta.className = 'cy-mb-meta';
        if (d.tag) {
          var tg = document.createElement('span');
          tg.className = 'cy-mb-tag ' + (Array.prototype.filter.call(d.tag.classList, function (c) { return c.indexOf('is-') === 0; })[0] || '');
          tg.textContent = d.tag.textContent.trim();
          meta.appendChild(tg);
        }
        /* the stock label, top-left like the desktop card (owner 2026-09-30) */
        if (d.stock) {
          var st = document.createElement('span');
          st.className = 'cy-mb-stock ' + Array.prototype.filter.call(d.stock.classList, function (c) { return c.indexOf('cy-stock') === 0; }).join(' ');
          st.textContent = d.stock.textContent.trim();
          meta.insertBefore(st, meta.firstChild);
        }
        if (meta.firstChild) copy.appendChild(meta);
        if (d.brand) a.classList.add('cy-mb-brand');
        if (d.src) {
          var img = document.createElement('img');
          img.className = 'cy-mb-art' + (d.brand ? ' cy-mb-art--brand' : '');
          /* lazy BEFORE src (2026-09-30): setting src first started the download at once, so the closed drawer's 57
             renders (~0.9 MB) loaded on every page, desktop included */
          img.loading = 'lazy';
          img.decoding = 'async';
          img.alt = '';                                          /* decorative - the row names it */
          img.setAttribute('aria-hidden', 'true');
          img.src = d.src;
          a.insertBefore(img, copy);
        }
        a.classList.add('cy-has-art');
      });
    });
  }

  /* ---- group labels: icon + two-line split ----------------------------- */
  function groupIconMap() {
    var m = {};
    document.querySelectorAll('.cy-mega__tab').forEach(function (b) {
      var icon = b.querySelector('.cy-mega__tab-icon');
      if (!icon) return;
      var main = b.querySelector('.cy-mega__tab-main');
      var sub = b.querySelector('.cy-mega__tab-sub');
      var label = (main ? main.textContent.trim() : '') +
        (sub && sub.textContent.trim() ? ' — ' + sub.textContent.trim() : '');
      m[label.toLowerCase()] = icon.currentSrc || icon.getAttribute('src');
      /* also by link: the sub line now comes from the collection description, so the label may not match the
         Navigation title any more (2026-09-29) */
      var href = (b.getAttribute('href') || '').split(/[?#]/)[0];
      if (href) m['href:' + href] = icon.currentSrc || icon.getAttribute('src');
    });
    return m;
  }

  /* collection handle -> sub-heading (its description), printed by the mega panels as [data-cy-col-subs] */
  function subsMap() {
    var m = {};
    document.querySelectorAll('[data-cy-col-subs]').forEach(function (el) {
      try { var o = JSON.parse(el.textContent); for (var k in o) if (o[k]) m[k] = o[k]; } catch (e) {}
    });
    return m;
  }

  function decorateGroups() {
    var icons = groupIconMap(), subs = subsMap();
    document.querySelectorAll('.hdt-header-menu-mobile .hdt-mb-sub-menu-lever-1 > li > hdt-accordion > details > summary .hdt-menu-link-text')
      .forEach(function (t) {
        var raw = (t.textContent || '').trim();

        /* the tab's icon, ahead of the label */
        var summary = t.closest('summary');
        var url = summary ? (summary.getAttribute('data-url') || '').split(/[?#]/)[0] : '';
        var src = icons['href:' + url] || icons[raw.toLowerCase().replace(/\s+/g, ' ')];
        if (src && summary && !summary.querySelector('.cy-mb-gicon')) {
          var img = document.createElement('img');
          img.className = 'cy-mb-gicon';
          img.loading = 'lazy';                                  /* before src, as above */
          img.alt = '';
          img.setAttribute('aria-hidden', 'true');
          img.src = src;
          summary.insertBefore(img, summary.firstChild);
        }

        if (t.querySelector('.cy-mb-glabel-sub')) return;        /* never twice */
        /* "APEX Premium: Licensed Editions" (titles since the 2026-10-07 copy pass; the old " — " form still works) */
        var cut = raw.match(/\s+—\s*|:\s+/);
        if (!cut) return;
        var i = cut.index;
        t.textContent = raw.slice(0, i).trim();
        var sub = document.createElement('span');
        sub.className = 'cy-mb-glabel-sub';
        var handle = url.indexOf('/collections/') === 0 ? url.split('/collections/')[1].split('/')[0] : '';
        sub.textContent = subs[handle] || raw.slice(i + cut[0].length).trim();   /* the description, else the Navigation title */
        t.appendChild(sub);
      });
  }

  /* ---- the Compare row (loud) and the View All row (minimal) ----------- */
  function decorateCta() {
    document.querySelectorAll('.hdt-header-menu-mobile .hdt-mb-sub-menu-lever-1 > li > a.hdt-menu-link')
      .forEach(function (a) {
        var label = (a.textContent || '').trim();
        if (!a.classList.contains('cy-mb-cta') && CTA_LABEL.test(label)) {
          /* the locked LIGHT button (2026-09-28, mobile-menu unlock): .hdt-menu-link comes off so no row rule
             paints it; the component (.cy-sys .cys-btn.cys-btn--light) does. The <li> seats it. */
          a.classList.add('cy-mb-cta', 'cys-btn', 'cys-btn--light');
          a.classList.remove('hdt-menu-link');
          if (a.parentElement) a.parentElement.classList.add('cy-mb-cta-li');
          a.insertAdjacentHTML('beforeend', ARROW);
        }
        /* "View All Chairs" and friends: the quiet twin, kept small */
        if (!a.classList.contains('cy-mb-quiet') && /^view all /i.test(label)) {
          a.classList.add('cy-mb-quiet');
        }
      });
  }

  /* ---- WhatsApp, outside the menus ------------------------------------- */
  /* It used to live inside Support, three taps deep. It is a contact action,
     not a navigation item, so it sits with the help notice where someone who
     is stuck will actually look.

     The number comes from Theme settings > Cybeart Custom (cy_whatsapp, via
     the window.CY_SETTINGS bridge). No bridge at all -> the built-in number;
     bridge present but the field cleared -> no row (that is the off switch). */
  /* 2026-10-21 (owner: "tel:+19056290010 this calling number in US update and replace for Whatsapp button for direct calling"): the row calls
     the number in Theme settings > Cybeart Custom > Call number (a tel: link, the phone icon in the brand red, the label from Call row label);
     WhatsApp only when the call number is cleared. */
  var PHONE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M21 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 1.1 4.2 2 2 0 0 1 3.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L7 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z"/></svg>';
  function mountWhatsApp() {
    var cfg = window.CY_SETTINGS;
    var call = (cfg && 'call' in cfg) ? cfg.call : '+1 905 629 0010';
    var callNum = String(call || '').replace(/[^\d+]/g, '');
    if (callNum.replace(/\D/g, '')) {
      var label = (cfg && cfg.callLabel) || 'Call Us';
      document.querySelectorAll('.hdt-header-menu-mobile .hdt-mobile-other-content').forEach(function (host) {
        if (host.querySelector('[data-cy-whatsapp]')) return;
        var notice = host.querySelector('.hdt-notice-mobile');
        var a = document.createElement('a');
        a.className = 'cy-mb-whatsapp cy-mb-whatsapp--call';
        a.setAttribute('data-cy-whatsapp', '');
        a.href = 'tel:' + (callNum.charAt(0) === '+' ? callNum : '+' + callNum);
        a.setAttribute('aria-label', label + ' ' + String(call));
        a.innerHTML = PHONE + '<span class="cy-mb-copy"><span class="cy-mb-whatsapp__label"></span><span class="cy-mb-sub"></span></span>';
        a.querySelector('.cy-mb-whatsapp__label').textContent = label;
        a.querySelector('.cy-mb-sub').textContent = String(call);
        if (notice && notice.parentNode) notice.parentNode.insertBefore(a, notice.nextSibling);
        else host.appendChild(a);
      });
      return;
    }
    var num = (cfg && 'whatsapp' in cfg) ? cfg.whatsapp : '+91 81540 15999';
    var digits = String(num || '').replace(/\D/g, '');
    if (!digits) return;
    document.querySelectorAll('.hdt-header-menu-mobile .hdt-mobile-other-content').forEach(function (host) {
      if (host.querySelector('[data-cy-whatsapp]')) return;
      var notice = host.querySelector('.hdt-notice-mobile');
      var a = document.createElement('a');
      a.className = 'cy-mb-whatsapp';
      a.setAttribute('data-cy-whatsapp', '');
      a.href = 'https://wa.me/' + digits;
      a.target = '_blank';
      a.rel = 'noopener';
      a.innerHTML = WHATSAPP +
        '<span class="cy-mb-copy"><span class="cy-mb-whatsapp__label">WhatsApp Us</span>' +
        '<span class="cy-mb-sub"></span></span>';
      a.querySelector('.cy-mb-sub').textContent = String(num);
      if (notice && notice.parentNode) notice.parentNode.insertBefore(a, notice.nextSibling);
      else host.appendChild(a);
    });
  }

  function run() {
    /* the drawer is a Cybeart section for the button component + tokens (cy-section-system.css is on every page
       through the header's mega panels) */
    document.querySelectorAll('#menu_mobile, .hdt-header-menu-mobile').forEach(function (d) { d.classList.add('cy-sys'); });
    var map = buildMap();
    if (Object.keys(map).length) decorateCards(map);
    decorateGroups();
    decorateCta();
    mountWhatsApp();
  }

  function init() {
    run();
    document.addEventListener('shopify:section:load', run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* 2026-09-30 (design system Phase 3): the mega panels' images wait (lazy) until the shopper heads for the menu —
   first pointer or keyboard focus on the menu bar — then load at once, so they are ready before a panel opens. */
(function () {
  'use strict';
  if (window.CyMegaWarm) return; window.CyMegaWarm = true;
  function warm() {
    document.querySelectorAll('.hdt-main-header .cy-mega img[loading="lazy"], .hdt-main-header .hdt-mega-menu img[loading="lazy"]')
      .forEach(function (img) { img.loading = 'eager'; });
  }
  function arm() {
    var bar = document.querySelector('.hdt-main-header #hdt-nav-ul');
    if (!bar) return;
    var once = function () { bar.removeEventListener('pointerenter', once); bar.removeEventListener('focusin', once); warm(); };
    bar.addEventListener('pointerenter', once);
    bar.addEventListener('focusin', once);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
})();
